import { render, staticRenderFns } from "./BehaviourQuestion.vue?vue&type=template&id=7762b3f5&"
import script from "./BehaviourQuestion.vue?vue&type=script&lang=js&"
export * from "./BehaviourQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports